<template>
  <div id="footer" class="container-fluid">
    <div class="logo-box">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="logo图">
      </div>
      <div class="logo">
        <img src="@/assets/images/libaohouse.jpg" alt="logo图">
      </div>
    </div>
    <!--    <p class="title">利宝阁集团有限公司</p>-->
<!--    <ul class="safe">-->
<!--      <li>{{ $t('header.home') }}</li>-->
<!--      <li class="line">|</li>-->
<!--      <li>{{ $t('header.about') }}</li>-->
<!--      <li class="line">|</li>-->
<!--      <li>{{ $t('header.love') }}</li>-->
<!--      &lt;!&ndash;      <li>|</li>&ndash;&gt;-->
<!--      &lt;!&ndash;      <li>{{ $t('header.link')}}</li>&ndash;&gt;-->
<!--      <li>|</li>-->
<!--      <li>{{ $t('header.contact') }}</li>-->
<!--    </ul>-->
    <ul class="safe" style="margin-top: 20px;">
      <li @click="$router.push('/disclaimer')">{{ $t('footer.title1') }}</li>
      <li class="line">|</li>
      <li @click="$router.push('/terms-and-conditions')">{{ $t('footer.title2') }}</li>
      <li class="line">|</li>
      <li @click="$router.push('/privacy-policy')">{{ $t('footer.title3') }}</li>
    </ul>
    <p class="copy">Copyright &copy; {{ new Date().getFullYear() }} {{ $t('footer.company') }}</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
.safe {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
}

.safe li {
  margin: 0 10px;
}

.safe li:not(.line) {
  cursor: pointer;
}

#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #A88F70;
  overflow: hidden;
  text-align: center;
}

.logo-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  display: flex;
  justify-content: center;
  padding: 10px 0;
  //width: 95px;
  //height: 45px;
  //margin: 50px auto 20px;
}

.logo img {
  width: 123px;
}
.logo:nth-child(1){
  margin-right: 30px;
}
.logo:nth-child(1) img {
  height: 100px;
}

.logo:nth-child(2) img {
  height: 130px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue